module.exports = __webpack_public_path__ + "static/bigminer-qr-97fa9efde88fd47f5e50170e6d0a2d13.png";